import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-node-status",
  "use": "icon-node-status-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-node-status\">\n<g id=\"icon-node-status_icon\" clip-path=\"url(#icon-node-status_clip0_341_35203)\">\n<path id=\"icon-node-status_Vector\" d=\"M8 0.964844C4.11439 0.964844 0.964478 4.11461 0.964478 8.00007C0.964478 11.8855 4.11439 15.0353 8 15.0353C11.8856 15.0353 15.0355 11.8855 15.0355 8.00007C15.0355 4.11461 11.8856 0.964844 8 0.964844ZM7.51039 10.503L6.5042 11.5087L5.49746 10.503L3.48452 8.48993L4.49073 7.48378L6.50383 9.49608L11.5089 4.49141L12.5155 5.49756L7.51039 10.503Z\" fill=\"#84BF40\" />\n</g>\n<defs>\n<clipPath id=\"icon-node-status_clip0_341_35203\">\n<rect width=\"16\" height=\"16\" fill=\"white\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/node-status.svg
// module id = YugZ
// module chunks = 103